import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
  timeout: 10000
});

// 请求拦截器：自动附加 Token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('wt_token');
  if (token) {
    config.headers.Authorization = 'Bearer ' + token;
  }
  return config;
});

// 响应拦截器：统一处理鉴权失败
api.interceptors.response.use(
  (res) => res.data,
  (err) => {
    if (err.response && err.response.status === 401) {
      localStorage.removeItem('wt_token');
      localStorage.removeItem('wt_user');
      if (location.pathname !== '/login') {
        location.href = '/login';
      }
    }
    return Promise.reject(err);
  }
);

// ==================== 鉴权 ====================

export const authApi = {
  login(data) {
    return api.post('/auth/login', data);
  },
  logout() {
    return api.post('/auth/logout');
  },
  info() {
    return api.get('/auth/info');
  },
  changePassword(data) {
    return api.post('/auth/change-password', data);
  }
};

// ==================== 用户管理（超管） ====================

export const adminUserApi = {
  list(params) {
    return api.get('/admin/user/list', { params });
  },
  create(data) {
    return api.post('/admin/user/create', data);
  },
  update(data) {
    return api.post('/admin/user/update', data);
  },
  delete(id) {
    return api.post('/admin/user/delete', { id });
  },
  detail(id) {
    return api.get('/admin/user/detail', { params: { id } });
  },
  assignPermissions(data) {
    return api.post('/admin/user/assign', data);
  },
  getPermissions(id) {
    return api.get('/admin/user/permissions', { params: { id } });
  }
};

// ==================== 网站管理 ====================

export const websiteApi = {
  list(params) {
    return api.get('/website/list', { params });
  },
  create(data) {
    return api.post('/website/create', data);
  },
  update(data) {
    return api.post('/website/update', data);
  },
  delete(id) {
    return api.post('/website/delete', { id });
  },
  detail(id) {
    return api.get('/website/detail', { params: { id } });
  }
};

// ==================== 统计分析 ====================

export const statsApi = {
  overview(params) {
    return api.get('/stats/overview', { params });
  },
  dailyTrend(params) {
    return api.get('/stats/daily-trend', { params });
  },
  monthlyTrend(params) {
    return api.get('/stats/monthly-trend', { params });
  },
  trend(params) {
    return api.get('/stats/trend', { params });
  },
  referer(params) {
    return api.get('/stats/referer', { params });
  },
  ip(params) {
    return api.get('/stats/ip', { params });
  },
  locationStats(params) {
    return api.get('/stats/location-stats', { params });
  },
  device(params) {
    return api.get('/stats/device', { params });
  },
  recent(params) {
    return api.get('/stats/recent', { params });
  },
  ranking(params) {
    return api.get('/stats/ranking', { params });
  },
  pageAnalytics(params) {
    return api.get('/stats/page-analytics', { params });
  },
  visitorBehavior(params) {
    return api.get('/stats/visitor-behavior', { params });
  },
  // 行为深度分析
  visitPath(params) {
    return api.get('/stats/visit-path', { params });
  },
  hourlyDistribution(params) {
    return api.get('/stats/hourly-distribution', { params });
  },
  weeklyDistribution(params) {
    return api.get('/stats/weekly-distribution', { params });
  },
  sourceChannel(params) {
    return api.get('/stats/source-channel', { params });
  },
  pageStayDuration(params) {
    return api.get('/stats/page-stay-duration', { params });
  },
  // 实时监控
  realtimeOverview(params) {
    return api.get('/stats/realtime/overview', { params });
  },
  realtimeOnlineVisitors(params) {
    return api.get('/stats/realtime/online-visitors', { params });
  },
  realtimeTrend(params) {
    return api.get('/stats/realtime/trend', { params });
  },
  realtimeRecent(params) {
    return api.get('/stats/realtime/recent', { params });
  },
  realtimeLocation(params) {
    return api.get('/stats/realtime/location', { params });
  },
  realtimeHotPages(params) {
    return api.get('/stats/realtime/hot-pages', { params });
  },
  suspiciousIp(params) {
    return api.get('/stats/suspicious-ip', { params });
  },
  suspiciousIpDetail(params) {
    return api.get('/stats/suspicious-ip-detail', { params });
  },
  getSuspiciousConfig() {
    return api.get('/stats/suspicious-config');
  },
  updateSuspiciousConfig(data) {
    return api.post('/admin/suspicious-config', data);
  },
  // IP禁用列表
  getBlockedIps() {
    return api.get('/stats/ip-blocklist/blocked');
  },
  ipBlocklistList(params) {
    return api.get('/stats/ip-blocklist', { params });
  },
  addIpBlocklist(data) {
    return api.post('/stats/ip-blocklist/add', data);
  },
  removeIpBlocklist(data) {
    return api.post('/stats/ip-blocklist/remove', data);
  },
  deleteIpBlocklist(data) {
    return api.post('/stats/ip-blocklist/delete', data);
  },
  ipManageList(params) {
    return api.get('/stats/ip-manage/list', { params });
  },
  ipManageDetail(params) {
    return api.get('/stats/ip-manage/detail', { params });
  }
};
